import { useCallback } from "react";
import { useHistory } from "react-router-dom";
import { first, get, size } from "lodash";
import { TAG_ATTRIBUTE_TYPES } from "src/consts/tags";
import URL, { url as urlHelper } from "src/consts/urlPaths";
import { personDetailsPath } from "../util/routing";
import { getTagId } from "../util/tags";
import { EVENT_TRACKING } from "../consts/eventTracking";
import { trackEvent } from "../services/segment";

const useHandleEntityTagClick = () => {
  const history = useHistory();
  return useCallback(
    (tag) => {
      // Use getTagId to handle both legacy and new tag object structures
      const tagId = getTagId(tag);
      if (tagId && history) {
        const values = get(tag, "tagTypeConfig.attributes.values");
        const attribute = first(values);
        const hasOnlyPersonAttribute =
          size(values) === 1 && attribute?.type === TAG_ATTRIBUTE_TYPES.PERSON;
        const personId = get(tag, `attributes.[${attribute?.id}]`);
        const url =
          hasOnlyPersonAttribute && personId
            ? personDetailsPath({ aggregateId: personId })
            : urlHelper(URL.TAG_DETAILS, { id: tagId });
        trackEvent(EVENT_TRACKING.TAG_CLICKED, {
          action: "tag_badge_selected",
        });
        history.push(url);
      }
    },
    [history]
  );
};

export default useHandleEntityTagClick;
